import { logger } from "@/utils/logger";
import { sendGTMEvent } from "@next/third-parties/google";

const standardFBEvents = [
	"AddPaymentInfo",
	"AddToCart",
	"AddToWishlist",
	"CompleteRegistration",
	"Contact",
	"CustomizeProduct",
	"Donate",
	"FindLocation",
	"InitiateCheckout",
	"Lead",
	"Purchase",
	"Schedule",
	"Search",
	"StartTrial",
	"SubmitApplication",
	"Subscribe",
	"ViewContent",
];

interface TrackEventParams {
	google?: { event?: string; options?: Record<string, unknown> };
	facebook?: { event?: string; options?: Record<string, unknown> };
	matomo?: { event?: string; options?: Record<string, unknown> };
	mixpanel?: { event?: string; options?: Record<string, unknown> };
}

export function trackEvent({
	google: { event: gev, options: go } = {},
	facebook: { event: fev, options: fo } = {},
	matomo: { event: mev, options: mo } = {},
	mixpanel: { event: mxev, options: mxo } = {},
}: TrackEventParams = {}) {
	// make it error safe
	try {
		// Use the new Web Worker bridge if available
		if (typeof window !== "undefined" && window.trackEvent && window.trackEvent !== trackEvent) {
			window.trackEvent({
				facebook: fev ? { event: fev, options: fo } : undefined,
				google: gev ? { event: gev, options: go } : undefined,
				matomo: mev ? { event: mev, options: mo } : undefined,
				mixpanel: mxo ? { event: mxev, options: mxo } : undefined,
			});
			return;
		}

		// Fallback to direct analytics calls (for development or when worker isn't available)
		if (window.fbq && fev) {
			const method = standardFBEvents.includes(fev) ? "track" : "trackCustom";
			window.fbq(method, fev, fo);
		}
		sendGTMEvent({ event: gev, options: go });
		window._paq && mev && window._paq.push && window._paq.push(["trackEvent", mo?.category || mev, mev]);
		if (window._paq && !window._paq.push) {
			// eslint-disable-next-line no-console
			console.warn(window._paq);
		}
		window.mixpanel && mxev && window.mixpanel.track(mxev);
	} catch (error) {
		logger.debug("Analytics tracking error :", error);
	}
}
